import PageLayout from './layout/page_layout'
import HomeComponent from '@/components/homepage'
import { useFeatureFlagEnabled } from 'posthog-js/react'
import Reports from './reports'

export default function Home({ page }) {
  const isDynamicHomepageEnabled = useFeatureFlagEnabled('use-updated-homepage')
  if (isDynamicHomepageEnabled) {
    return <PageLayout component={<HomeComponent />} />
  } else {
    return <Reports component={page} />
  }
}
